<template>
  <div>
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn"
                       :descripcion="'Imprime las facturas vencidas.'"
                       :titulo="'Reporte de Análisis de Antigüedad de Facturas'"
                       @MethodAnular="anular"
                       @MethodEliminar="remove" @MethodGuardar="save" @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo"
                       @abrirBarraTablaDinamica="abrirTabla"/>
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">

            <!-- Formulario-Analisis de Antigüedad-->
            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000;">

                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png">
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px;"> Reporte de Análisis de Antigüedad de
                    Facturas </span>

                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  fecha  -->
                        <v-text-field v-model="AnalisisAntiguedad.Fecha" :rules="[$rules.required]" dense
                                      label="Fecha de corte:" outlined
                                      type="date">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>

                        </v-text-field>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-combobox v-model="AnalisisAntiguedad.tipocliente" :items="RtipoCliente" autocomplete="off"
                                    dense item-text="descripcion"
                                    label="Tipo de Cliente:" outlined
                                    @blur="SelctCbTipoCliente"
                                    @focus="cargarTipoCliente">
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                        <!-- ----------------------------- Vendedor @keyup="CbFilvendedor" -->

                        <v-combobox v-model="AnalisisAntiguedad.vendedor" :items="Rvendedor" autocomplete="off" dense
                                    item-text="nombre"
                                    label=" Vendedor:" outlined required style="font-size: 13px;"
                                    @blur="SelctCbvendedor" @focus="CargarRvendedor">
                          <template slot="item" slot-scope="item">
                            <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                   md="12" sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>Descripción:
                                {{ item.item.nombre }}</b></p>
                              <span class="pa-0 ma-0 py-0 my-0">
                                <span class="pe-1" style="border: 1px dashed  #616161;"><b>Cedula.: </b>
                                  {{ item.item.cedula }} </span>
                                <span class="pe-1" style="border: 1px dashed  #616161;"><b>Telefono: </b>
                                  {{ item.item.telefono }} </span>
                                <!-- <span class="pe-1" style="border: 1px dashed  #616161;"><b>Placa: </b> {{item.item.placa }} </span> -->
                              </span>
                            </v-col>

                          </template>

                          <template v-slot:prepend>
                            <i class="fa fa-universal-access" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  Cliente  -->
                        <v-combobox v-model="AnalisisAntiguedad.cliente" :items="Rcliente" autocomplete="off" dense
                                    item-text="codnom"
                                    label="Cliente:" no-filter outlined
                                    @blur="SelctCbClient" @focus="cargarCliente" @keyup="CbFilcliente">
                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                              }}</span>
                            <span
                            ><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span
                                class=" colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre.trim() }}</span>
                          </template>
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle-o" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-combobox>

                        <!--- Subtipo de Cliente --->
                        <v-autocomplete
                            v-model="AnalisisAntiguedad.subtipoCliente"
                            :items="AnalisisAntiguedad.tipocliente ? AnalisisAntiguedad.tipocliente.subtipos : AnalisisAntiguedad.subtipo || []"
                            clearable
                            dense
                            item-text="descripcion"
                            label="Subtipo"
                            outlined
                            return-object
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                        <v-combobox v-model="AnalisisAntiguedad.moneda" :items="Rmoneda" autocomplete="off" dense
                                    item-text="nombrecorto"
                                    label="Moneda" outlined @blur="SelctCbMoneda"
                                    @focus="cargarMoneda">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-combobox>


                        <div class="d-flex justify-center">
                          <v-switch v-model="AnalisisAntiguedad.Resumen" class="mt-0" color="teal" hide-details
                                    inset
                                    label="Formato Resumido:">
                            <template v-slot:label>
                              <strong style="color:#000000;">
                                {{
                                  AnalisisAntiguedad.Resumen ? 'Formato Resumido: Si' : 'Formato Resumido: No'
                                }}</strong>
                            </template>
                          </v-switch>
                        </div>

                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>

                <ModalReporteFiltros2 :Datos="AnalisisAntiguedad" @DataReporteBasico="DDataReporteBasico"/>

              </v-card>
            </v-container>
            <!-- fn Formulario-Analisis de Antigüedad-->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->

      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr/>

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr/>
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          ">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import {EventBus} from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros2 from "../../components/ModalReporteFiltros2";
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  getParamFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoBasico,
  RedondeoValor,
  RedondeoValorCantRed
} from "@/js/Funciones.js";

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros2

  },
  created() {
    var json = {
      titulo: "Reporte de Análisis de Antiguedad de Facturas",
      descripcion: "Imprime las facturas vencidas.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [
        "ReporteAnalisisAntiguedadNew",
        "ReporteAnalisisAntiguedadSave",
        "ReporteAnalisisAntiguedadRemove",
        "ReporteAnalisisAntiguedadAnular",
        "ReporteAnalisisAntiguedadPrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReporteAnalisisAntiguedadNew", this.new);
    EventBus.$on("ReporteAnalisisAntiguedadSave", this.save);
    EventBus.$on("ReporteAnalisisAntiguedadRemove", this.remove);
    EventBus.$on("ReporteAnalisisAntiguedadAnular", this.remove);
    EventBus.$on("ReporteAnalisisAntiguedadPrintList", this.imprimirList);
    EventBus.$on("emitReporteAnalisisAntiguedad", this.datostabla);

    EventBus.$on("onResize", this.onResize);
  },

  data: () => ({
    RtipoCliente: [],
    Rcliente: [],
    Rvendedor: [],
    Rmoneda: [],

    ListaTiposClientes: [],
    windowSize: {width: "auto", height: "auto"},
    AnalisisAntiguedad: {
      nombre: 'Antiguedad de Facturas',
      UrlImprimir: '/reportescxc/ImprimirAntiguedadfacturas',
      UrlExel: '/reportescxc/ExcelAntiguedadfacturas',
      UrlCorreo: '/reportescxc/CorreoAntiguedadfacturas',
      vendedor: null,
      Resumen: true,
      tipocliente: null,
      subtipoCliente: null,
      cliente: null,
      moneda: null,
      Fecha: fechaNueva(),
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{text: "Tipo Clientes", value: "descripcion"}],

    slotlist: [
      {dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:"},
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      {dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo"},
    ],

    slotHtabla: [
      {text: "Código", value: "codigo"},
      {text: "Descripcion", value: "descripcion"}
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),

  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoValor,
    RedondeoBasico,
    RedondeoValorCantRed,
    fechaNueva,
    getParamFecha,

    onResize(e) {
      this.windowSize = e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },

    datostabla(e) {
      this.AnalisisAntiguedad = e;
      this.acti_tb_data = false
    },
    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },

    // Retorna los datos del componente ModalReporteFiltros2
    DDataReporteBasico() {
    },
    imprimirList() {
    },
    newwnuevo() {
      (this.AnalisisAntiguedad = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
          EventBus.$emit("actualizaBarraBusqueda2");
    },


    // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
    cargarCliente() {

      this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3/25/0', {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rcliente = res.data))
    },


    // El código anterior intenta verificar si el usuario ha seleccionado un cliente del menú
    // desplegable. Si el usuario no ha seleccionado un cliente, entonces el código está intentando
    // establecer el cliente en nulo.
    SelctCbClient() {

      var _this = this;
      setTimeout(function () {
        if (_this.AnalisisAntiguedad.cliente == null) {
          _this.AnalisisAntiguedad.cliente = "";
        }

        if (!_this.AnalisisAntiguedad.cliente.hasOwnProperty('codigo')) {
          _this.AnalisisAntiguedad.cliente = "";
          _this.AnalisisAntiguedad.cliente = null;
          return;
        }
      }, 300);

      /*  if (this.AnalisisAntiguedad.cliente == null) {
          this.AnalisisAntiguedad.cliente = "";
        }
  
        if (this.AnalisisAntiguedad.cliente.codigo == undefined) {
          this.alerta("Seleccione un cliente", "error");
          this.AnalisisAntiguedad.cliente = "";
          return;
        }*/

    },

    CbFilcliente(e) {
      //console.log(e.target.value)

      if (e.target.value.length >= 0) {

        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? 'A' : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.Rcliente = res.data));
      }
    },

    // Llamar a una API y obtener los datos de la API y almacenarlos en la variable RtipoCliente.
    cargarTipoCliente() {
      this.$axios.get(this.$hostname + this.$hName + '/tipoclientes/findall', {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RtipoCliente = res.data))
    },

    // Comprobando si el valor es nulo o indefinido.
    SelctCbTipoCliente() {

      var _this = this;
      setTimeout(function () {
        if (_this.AnalisisAntiguedad.tipocliente == null) {
          _this.AnalisisAntiguedad.tipocliente = "";
        }

        if (!_this.AnalisisAntiguedad.tipocliente.hasOwnProperty('codigo')) {
          _this.AnalisisAntiguedad.tipocliente = "";
          _this.AnalisisAntiguedad.tipocliente = null;
          return;
        }
      }, 300);
    },

    // Llamar a la API y obtener los datos de la API y almacenarlos en la variable Rvendedor.
    CargarRvendedor() {
      this.$axios.get(this.$hostname + this.$hName + '/vendedores/findallactiv', {headers: this.$store.getters.GetheadersAxios}
      ).then(res => {
        this.Rvendedor = res.data;
      });
    },

    // El código anterior está comprobando si el usuario ha seleccionado un valor del menú desplegable.
    // Si el usuario no ha seleccionado un valor, entonces el código establece el valor en nulo.
    SelctCbvendedor() {
      var _this = this;
      setTimeout(function () {
        if (_this.AnalisisAntiguedad.vendedor == null) {
          _this.AnalisisAntiguedad.vendedor = "";
        }

        if (!_this.AnalisisAntiguedad.vendedor.hasOwnProperty('codigo')) {
          _this.AnalisisAntiguedad.vendedor = "";
          _this.AnalisisAntiguedad.vendedor = null;
          return;
        }
      }, 300);
    },

    // Llamar a una API y obtener los datos de la API.
    cargarMoneda() {
      this.$axios.get(this.$hostname + this.$hName + '/monedas/findallActivos/',
          {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rmoneda = res.data))
    },

    // Comprobando si el valor es nulo o indefinido.
    SelctCbMoneda() {

      var _this = this;
      setTimeout(function () {
        if (_this.AnalisisAntiguedad.moneda == null) {
          _this.AnalisisAntiguedad.moneda = "";
        }

        if (!_this.AnalisisAntiguedad.moneda.hasOwnProperty('codigo')) {
          _this.AnalisisAntiguedad.moneda = "";
          _this.AnalisisAntiguedad.moneda = null;
          return;
        }
      }, 300);
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e);
        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },

    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
    }
  }
};
</script>

<style>
</style>
